import React from 'react';
import { Box } from '@rsos/components/capstone/base';
import { trackSendPreconfiguredMessageClick } from '../textFrom911Trackings';
import { StartMessagesContainer } from './TF911.styles';
import TF911StartMessage from './TF911StartMessage';

/**
 * @param {Boolean} isCreatingConversation - Loading state for creating conversation
 * @param {Array} preconfiguredMessages - List of preconfigured messages
 * @param {Function} onSendMessageClick - Callback function for using the
 * preconfigured message to start the chat
 */
const TF911StartChatMessages = ({
  isCreatingConversation,
  preconfiguredMessages,
  onSendMessageClick,
  isUniteEventPaneEnabled,
  isForOverview,
  gpxFeature,
}) => {
  const handleMessageSendClick = (message, index) => {
    trackSendPreconfiguredMessageClick({
      feature: gpxFeature,
      isUniteEventPaneEnabled,
      fromOverviewTab: isForOverview,
      messageIndex: index,
      message,
    });
    onSendMessageClick(message);
  };

  return (
    <StartMessagesContainer>
      {preconfiguredMessages.map((message, index) => {
        return (
          <Box key={message}>
            <TF911StartMessage
              isCreatingConversation={isCreatingConversation}
              message={message}
              onSendMessageClick={msg => handleMessageSendClick(msg, index)}
            />
          </Box>
        );
      })}
    </StartMessagesContainer>
  );
};

export default TF911StartChatMessages;
